<template>
  <div>
    <v-btn v-if="false" bottom color="primary" dark fab fixed right x-small style="z-index: 99999">
      {{ $vuetify.breakpoint.name }}
    </v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
